import React from 'react';
import Asterisk from '../common/Asterisk/Asterisk';
import Input from '../common/Input/Input';
import "./CommercialUnit.css";
import { FormError, getFormErrorByName, getFormErrorMessageByName, hasError, useFormErrorContext } from '../../utils/context/FormErrorContext';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface CommercialUnitInputFieldProps {
    formData: Record<string, unknown>,
    name: string,
    type?: string,
    errors: FormError[],
    heading: string,
    title?: string,
    disabled?: boolean,
    testId?: string,
    required?: boolean,
}

export default function CommercialUnitInputField(props: CommercialUnitInputFieldProps): JSX.Element {

    const className = hasError(props.errors, props.name) ? "unit-input table-error" : "border unit-input"
    const { removeError } = useFormErrorContext()
    return (
        <>
            <tr>
                <td className='label-cell'>
                    {props.heading} <Asterisk />
                </td>
            </tr>
            <tr>
                <td>
                    {props.type === "integer" ? 
                    <AIRPNumberInput 
                        formatType="integer"
                        initialValue={props.formData[props.name] as string}
                        className={className}
                        name={props.name}
                        tooltip={props.title}
                        negatives={false}
                        readOnly={props.disabled}
                        />
                    : 
                    <Input type="text" id={props.name} name={props.name}
                        value={props.formData[props.name] as string | undefined}
                        className={className}
                        title={props.title}
                        errorMessage={getFormErrorMessageByName(props.errors, props.name)}
                        hideErrorCross={true}
                        noTimer={true}
                        onChange={() => removeError(getFormErrorByName(props.errors, props.name)?.primaryKey as string)}
                        ariaLabel={props.heading}
                        positiveOnly={false}
                        disabled={props.disabled}
                        testid={props.testId}
                    />}
                    
                </td>
            </tr>
        </>
    );
}
